export const selectionTypes = {
  METRIC: 'metric',
  SCALE: 'scale',
  BENCHMARK: 'benchmark',
  CLASS: 'class',
  STUDENT: 'student',
  SCHOOL: 'school',
}

export const states = {
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
}

export const dropdownTypes = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
}

export const reportTypes = {
  BENCHMARK: 'BENCHMARK',
  TRACKING: 'TRACKING',
  PROGRESS: 'PROGRESS',
  PARENT: 'PARENT',
  DIAGNOSTIC: 'DIAGNOSTIC',
  PLANNING: 'PLANNING',
  DYSLEXIA: 'DYSLEXIA',
  DYSLEXIARISK: 'DYSLEXIARISK',
  READINGROPE: 'READINGROPE',
  SKILLSSTATUS: 'SKILLSSTATUS',
  SKILLSDIAGNOSTIC: 'SKILLSDIAGNOSTIC',
  BADGING: 'BADGING',
  CLASSPROGRESS: 'CLASSPROGRESS',
}

export default {
  selectionTypes,
  states,
  dropdownTypes,
  reportTypes,
}

